export default "__VITE_ASSET__C7N3ezTD__"